
import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const scrollToNewsletter = () => {
    const newsletterSection = document.querySelector('section.section-padding');
    if (newsletterSection) {
      window.scrollTo({
        top: newsletterSection.getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
      closeMobileMenu();
    }
  };

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out py-4",
        isScrolled 
          ? "bg-white/80 backdrop-blur-md shadow-sm" 
          : "bg-transparent"
      )}
    >
      <div className="container-narrow flex items-center justify-between">
        <a href="#" className="font-display text-xl font-medium text-primary">
          SwifQuery
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#features" className="text-sm font-medium link-underline">Features</a>
          <a href="#use-cases" className="text-sm font-medium link-underline">Use Cases</a>
          <a href="#about" className="text-sm font-medium link-underline">About</a>
          <a href="#contact" className="text-sm font-medium link-underline">Contact</a>
          <Button size="sm" className="rounded-full" onClick={scrollToNewsletter}>
            Join Beta
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-foreground" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div 
        className={cn(
          "fixed inset-0 bg-background z-40 transition-transform duration-300 ease-in-out md:hidden pt-20",
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        )}
      >
        <nav className="flex flex-col items-center space-y-8 p-8">
          <a 
            href="#features" 
            className="text-lg font-medium" 
            onClick={closeMobileMenu}
          >
            Features
          </a>
          <a 
            href="#use-cases" 
            className="text-lg font-medium" 
            onClick={closeMobileMenu}
          >
            Use Cases
          </a>
          <a 
            href="#about" 
            className="text-lg font-medium" 
            onClick={closeMobileMenu}
          >
            About
          </a>
          <a 
            href="#contact" 
            className="text-lg font-medium" 
            onClick={closeMobileMenu}
          >
            Contact
          </a>
          <Button 
            size="lg" 
            className="w-full rounded-full mt-4" 
            onClick={scrollToNewsletter}
          >
            Join Beta
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
